import { h } from 'preact';
// import Store from 'store/store';
import { loadScript, parseDate } from 'utils/utils';

import Form from 'components/bolt/forms/form/form';
import Field from 'components/bolt/forms/field/field';

import s from 'components/bolt/forms/chains/amc/form.sss';

export default class AmcForm extends Form {
	constructor(props) {
		super(props);
		this.shouldRenderCaptcha = true;
		// this.onKeyDown = debounce(this.onKeyDown.bind(this), 500);
	}

	async componentDidMount() {
		await loadScript('https://cdn01.jotfor.ms/static/prototype.forms.js?3.3.35637');
		await loadScript('https://cdn02.jotfor.ms/static/jotform.forms.js?3.3.35637');
	}


	renderJotCaptcha = () => {
		const { formId, data } = this.props;
		return (
			<div className={s.wrapper} id="customJotCaptcha">
				<p className={s.disclaimer}>AMC will never share your personal data. <a href="https://www.amctheatres.com/privacy-policy" target="_blank" rel="nofollow">Privacy Policy</a>.</p>
				<div className={s.notesText}>
					<div>By submitting this form I understand this form is only a request. A Special Events Consultant will be in touch within 3-5 business days. Your event is not confirmed until payment has been remitted. You will receive a submission confirmation email. If you don't receive, please check your SPAM or JUNK folders.</div>
				</div>
				<div className={s.container}>
					<img id="customJotCaptcha_captcha" className={s.loader} />
					<div className={s.inputContainer}>
						<Field
							formId={formId}
							ref={e => this.$captcha = e}
							id="captcha"
							name="captcha"
							value={data['captcha']}
							type="input"
							onInput={this.props.onChange}
							// onKeyDown={this.props.onChange}
							regex="[^\n]+"
							validationMessage="Please complete the captcha first"
							wrapperClass={s.captcha}
							required
						/>
						<input type="hidden" id="input_81_captcha_id" name="captcha_id" required />
						<div className={s.filler} />
						<img src="https://cdn.jotfor.ms/images/reload.png" height={20} alt="Reload" onClick={this.reloadJotCaptcha} />
					</div>
				</div>
			</div>
		);
	};


	renderCustomInput() {
		return this.renderJotCaptcha();
	}

	renderCaptcha() {
		// only run once
		if (this.shouldRenderCaptcha === true) {
			this.shouldRenderCaptcha = false;
			window.JotForm && window.JotForm.initCaptcha('customJotCaptcha');
		}
	}

	reloadJotCaptcha = (event) => {
		event.preventDefault();
		window.JotForm && window.JotForm.reloadCaptcha('customJotCaptcha');
	};


	renderHiddenFields = () => {
		const { movieTitle, amcName } = this.props;
		const dateData = parseDate(this.props.data.formDate);
		const dateToday = new Intl.DateTimeFormat('en-US').format(new Date());
		const date = dateData ? new Intl.DateTimeFormat('en-US').format(new Date(dateData)) : dateToday;
		const [month, day, year] = date.split('/'); 

		return 	(
			<div id="hidden-fields">
				<input type="hidden" name="formID" value="230295261872054" />
				{/* <input type="hidden" name="simple_spc" value="222265219027350-222265219027350" />
				<input type="hidden" name="event_id" value="1659359627399_222265219027350_ISCcuxG" /> */}
				<input type="hidden" id="JWTContainer" value="" />
				<input type="hidden" id="cardinalOrderNumber" value="" />

				<input type="hidden" name="q13_desiredLocation" value={amcName} />
				<input type="hidden" name="q16_desiredOpen" value={amcName} />
				<input type="hidden" name="q17_btLocation" value={amcName} />

				<input type="hidden" name="q85_btTitle" value={movieTitle} />
				{/* <input type="hidden" name="q9_whatType9" value="Playing in theatres (Current or Future)" /> */}

				<input type="hidden" name="q27_btDate[month]" value={month} />
				<input type="hidden" name="q27_btDate[day]" value={day} />
				<input type="hidden" name="q27_btDate[year]" value={year} />

				<input type="hidden" name="q3_eventType" value="Current/Future Release" />
				<input type="hidden" name="q98_filmPackage" value="Group Sale Buyout" />
				<input type="hidden" name="q21_teamhidden" value="Group Sale" />
				{/* <input type="hidden" name="q20_repEmail" value="" /> TODO Add emails from AMC */}
				<input type="hidden" name="q80_teamEmail" value="bookyourgroup@amctheatres.com" />
			</div>
		);
	};
}